import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import * as CONFIG from 'constants/config';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import Select from 'components/Select';
import QuestionItem from 'pages/QuestionsPage/QuestionItem';
import { AuthContext } from 'AuthProvider';

import { getCategoriesList } from 'backend/Category';
import { getSubcategoriesList } from 'backend/Subcategory';
import { getQuestionsList, createQuestion } from 'backend/Question';

const QuestionsPage = () => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [subcategoriesForAdd, setSubcategoriesForAdd] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionsAll, setQuestionsAll] = useState([]);
  const [categoriesAndSubcategories, setCategoriesAndSubcategories] = useState([]);
  const [selectedValue, setSelectedValue] = useState('all');
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAdd, setIsAdd] = useState(false);

  const [categoryUid, setCategoryUid] = useState('all');
  const [subcategoryUid, setSubcategoryUid] = useState('all');

  const [nameEn, setNameEn] = useState('');
  const [nameRu, setNameRu] = useState('');
  const [nameUk, setNameUk] = useState('');
  const [namePl, setNamePl] = useState('');
  const [nameIt, setNameIt] = useState('');
  const [nameEs, setNameEs] = useState('');
  const [namePt, setNamePt] = useState('');

  const [leadEn, setLeadEn] = useState('');
  const [leadRu, setLeadRu] = useState('');
  const [leadUk, setLeadUk] = useState('');
  const [leadPl, setLeadPl] = useState('');
  const [leadIt, setLeadIt] = useState('');
  const [leadEs, setLeadEs] = useState('');
  const [leadPt, setLeadPt] = useState('');

  const lang = getLanguage();
  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    if (categoryUid !== 'all') {
      let subcategoriesLocal = [];
      subcategories.map((element) => {
        if (element.categoryUid === categoryUid) {
          subcategoriesLocal.push(element);
        }
      });
      setSubcategoriesForAdd(subcategoriesLocal);
    } else {
      setSubcategoriesForAdd([]);
    }
  }, [categoryUid]);
  
  useEffect(() => {
    if (categories.length === 0) {
      getCategoriesList()
      .then((result) => {
        setCategories(result);
      })
      .catch((error) => {
        console.log('error', error);
        setCategories([]);
      });
    }
  }, [categories.length]);

  useEffect(() => {
    if (subcategories.length === 0) {
      getSubcategoriesList()
        .then((result) => {
          setSubcategories(result);
        })
        .catch((error) => {
          console.log('error', error);
          setSubcategories([]);
        });
    }
  }, []);

  useEffect(() => {
    if (questions.length === 0) {
      getQuestionsList()
        .then((result) => {
          setQuestionsAll(result);
          const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);

          setQuestions(getQuestionsByPage(result));
        })
        .catch((error) => {
          console.log('error', error);
          setQuestions([]);
          setQuestionsAll([]);
        });
    }
  }, []);

  useEffect(() => {
    getCategoryAndSubcategory();
  }, [categories, subcategories]);

  useEffect(() => {
    setQuestions(getQuestionsByPage(questionsAll));
  }, [currentPage]);

  const getCategoryAndSubcategory = () => {
    let result = [];
    if (categories.length > 0 && subcategories.length > 0) {
      subcategories.map((element) => {
        const itemCategory = categories.find((x) => x.alias === element.categoryUid);
        let resultItem = {
          alias: element.alias,
          name: {
            ru: itemCategory.name.ru + ': ' + element.name.ru
          }
        };
        result.push(resultItem);
      });
    }

    setCategoriesAndSubcategories(result);
  };

  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  const selectSubcategory = (value) => {
    setSelectedValue(value);
    getQuestionsList()
      .then((result) => {
        if (value !== 'all') {
          let arr = [];
          result.map((element) => {
            if (element.subcategoryUid === value) {
              arr.push(element)
            }
          });
          const countPages = Math.ceil(arr.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setQuestions(getQuestionsByPage(arr));
          setQuestionsAll(arr);
          setCurrentPage(1);
        } else {
          const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
          setPages(countPages);
          setQuestions(getQuestionsByPage(result));
          setQuestionsAll(result);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setQuestions([]);
        setQuestionsAll([]);
      });
  };

  const getQuestionsByPage = (items) => {
    let result = [];
    let i = 0;
    const fromPage = (currentPage - 1) * CONFIG.COUNT_PER_PAGE;
    const toPage = currentPage * CONFIG.COUNT_PER_PAGE;
    items.map((element) => {
      if (i >= fromPage && i < toPage) {
        result.push(element);
      }
      i++;
    })

    return result;
  };

  let pageBlock = [];
  if (pages > 1) {
    let arr = [];
    for (let i = 1; i <= pages; i++) {
      arr.push({page: i});
    }
    pageBlock = arr.map((element) => {
      if (currentPage === element.page) {
        return <button className="btn btn-light active" onClick={() => setCurrentPage(element.page)} key={element.page}>{element.page}</button>;
      } else {
        return <button className="btn btn-light" onClick={() => setCurrentPage(element.page)} key={element.page}>{element.page}</button>;
      }
    });
  }

  const clickOnAdd = () => {
    setIsAdd(true);
  };

  const selectNewCategory = (value) => {
    setCategoryUid(value);
  };

  const selectNewSubcategory = (value) => {
    setSubcategoryUid(value);
  };

  const onChangeText = (event, field) => {
    if (field === 'nameEn') setNameEn(event.target.value);
    if (field === 'nameRu') setNameRu(event.target.value);
    if (field === 'nameUk') setNameUk(event.target.value);
    if (field === 'namePl') setNamePl(event.target.value);
    if (field === 'nameIt') setNameIt(event.target.value);
    if (field === 'nameEs') setNameEs(event.target.value);
    if (field === 'namePt') setNamePt(event.target.value);

    if (field === 'leadEn') setLeadEn(event.target.value);
    if (field === 'leadRu') setLeadRu(event.target.value);
    if (field === 'leadUk') setLeadUk(event.target.value);
    if (field === 'leadPl') setLeadPl(event.target.value);
    if (field === 'leadIt') setLeadIt(event.target.value);
    if (field === 'leadEs') setLeadEs(event.target.value);
    if (field === 'leadPt') setLeadPt(event.target.value);
  };

  const onClickCancel = () => {
    setIsAdd(false);
  };

  const onClickSave = () => {
    if (categoryUid !== 'all' && subcategoryUid !== 'all') {
      createQuestion(
        categoryUid,
        subcategoryUid,
        nameEn,
        nameRu,
        nameUk,
        namePl,
        nameIt,
        nameEs,
        namePt,
        leadEn,
        leadRu,
        leadUk,
        leadPl,
        leadIt,
        leadEs,
        leadPt)
      .then(() => {
        setIsAdd(false);

        getQuestionsList()
          .then((result) => {
            setQuestionsAll(result);
            const countPages = Math.ceil(result.length / CONFIG.COUNT_PER_PAGE);
            setPages(countPages);
            setQuestions(getQuestionsByPage(result));
          })
          .catch((error) => {
            console.log('error', error);
            setQuestions([]);
            setQuestionsAll([]);
          });
      })
      .catch((error) => {
        console.log('createQuestion error', error);
      });
    } else {
      alert('Категория и подкатегория должны быть заполнены');
    }
  };

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="questions" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="breadcrumbs ace-save-state" id="breadcrumbs">
              <ul className="breadcrumb">
                <li>
                  <i className="ace-icon fa fa-home home-icon"></i>
                  <a href="/">Главная</a>
                </li>
                <li className="active">Вопросы</li>
              </ul>
            </div>
            <div className="page-content">
            {isAdd ? (
                <div className="row">
                  <div className="col-xs-12">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Категория</th>
                          <th>Подкатегория</th>
                          <th>EN</th>
                          <th>RU</th>
                          <th>UK</th>
                          <th>IT</th>
                          <th>PL</th>
                          <th>ES</th>
                          <th>PT</th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            <Select items={categories} placeholder="Категории" onChange={(event) => selectNewCategory(event.target.value)} selectedValue={categoryUid} index={1} withAll={true} />  
                          </td>
                          <td>
                            <Select items={subcategoriesForAdd} placeholder="Подкатегория" onChange={(event) => selectNewSubcategory(event.target.value)} selectedValue={subcategoryUid} index={2} withAll={true} />  
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameEn'}
                              placeholder="Название (EN)"
                              value={nameEn}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameEn')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadEn'}
                              placeholder="Описание (EN)"
                              value={leadEn}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadEn')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameRu'}
                              placeholder="Название (RU)"
                              value={nameRu}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameRu')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadRu'}
                              placeholder="Описание (RU)"
                              value={leadRu}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadRu')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameUk'}
                              placeholder="Название (UK)"
                              value={nameUk}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameUk')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadUk'}
                              placeholder="Описание (UK)"
                              value={leadUk}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadUk')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameIt'}
                              placeholder="Название (IT)"
                              value={nameIt}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameIt')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadIt'}
                              placeholder="Описание (IT)"
                              value={leadIt}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadIt')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-namePl'}
                              placeholder="Название (PL)"
                              value={namePl}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'namePl')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadPl'}
                              placeholder="Описание (PL)"
                              value={leadPl}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadPl')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-nameEs'}
                              placeholder="Название (ES)"
                              value={nameEs}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'nameEs')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadEs'}
                              placeholder="Описание (ES)"
                              value={leadEs}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadEs')}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={'form-namePt'}
                              placeholder="Название (PT)"
                              value={namePt}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'namePt')}
                            />
                            <br />
                            <br />
                            <input
                              type="text"
                              id={'form-leadPt'}
                              placeholder="Описание (PT)"
                              value={leadPt}
                              className="col-xs-12 col-sm-12"
                              onChange={(event) => onChangeText(event, 'leadPt')}
                            />
                          </td>
                          <td>
                          <button className="btn btn-success btn-xs" onClick={() => onClickSave()}>
                            <i className="ace-icon fa fa-save bigger-110 icon-only"></i>
                          </button>
                          &nbsp;&nbsp;
                          <button className="btn btn-grey btn-xs" onClick={() => onClickCancel()}>
                            <i className="ace-icon fa fa-reply bigger-110 icon-only"></i>
                          </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="row" style={{marginBottom: 10}}>
                  <div className="col-xs-12 text-right">
                    <button className="btn btn-success" onClick={() => clickOnAdd()}>Добавить</button>
                  </div>
                </div>
              )}
              <div className="row">
						  	<div className="col-xs-12">
								  <table id="simple-table" className="table  table-bordered table-hover">
									  <thead>
                          <tr>
                            <th>#</th>
                            <th>
                              Категория / Подкатегория
                              <br />
                              <Select
                                items={categoriesAndSubcategories}
                                placeholder="Категория / Подкатегория"
                                withAll={true}
                                onChange={(event) => selectSubcategory(event.target.value)}
                                selectedValue={selectedValue}
                              />
                            </th>
                            <th>Картинка</th>
                            <th>EN</th>
                            <th>RU</th>
                            <th>UK</th>
                            <th>IT</th>
                            <th>PL</th>
                            <th>ES</th>
                            <th>PT</th>
                            <th></th>
                          </tr>
										</thead>
										<tbody>
                          {questions.map((element, index) => {
                            const itemCategory = categories.find((x) => x.alias === element.categoryUid);
                            const itemSubcategory = subcategories.find((x) => x.alias === element.subcategoryUid);
                            return (<QuestionItem
                              question={element}
                              key={index}
                              index={index}
                              categoryNameRu={itemCategory.name.ru + ': '  + itemSubcategory.name.ru}
                              currentPage={currentPage}
                            />);
                          })}
                    </tbody>
								  </table>
                  <div className="btn-group">
                    {pageBlock}
                  </div>
								</div>
						  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionsPage;
